import { wsgSkpApiHeader } from './header'
import { getAccLevelResponse } from './responseHandler'
import { getAccountLevel3Endpoint } from '../firestore/getGdeSkpApiSettings'
import { HTTP_POST } from '../common/appConstants'
import { accountLevel3ReqBody } from './skpApiDataModel'

/**
 * 
 * @param {string} system environment info
 * @param {string} accountLevel1Code accountLevel1Code
 * @param {string} accountLevel2Code accountlevel1code
 * @param {string} accountLevel3Code accountLevel3Code
 * @returns {object} response from accountLevel1
 */
export const validateAndGetAccountLevel3 = async (system, accountLevel1Code, accountLevel2Code, accountLevel3Code) => {
  try {
    const result = await Promise.all([
      wsgSkpApiHeader(),
      getAccountLevel3Endpoint()
    ]) 
    const headerResponse = result[0]
    const apiUrl = result[1]
    const requestBody = accountLevel3ReqBody(system, accountLevel1Code, accountLevel2Code, accountLevel3Code)
    const accountLevel3Response = await getAccLevelResponse(HTTP_POST, apiUrl, requestBody, {}, headerResponse)
    return accountLevel3Response    
  } catch (error) {
    if (error?.message) {
      return { error: error.message }
    } else {
      return { error: error.errors[0].message ? error.errors[0].message : 'unexpected error occurred' }
    }
  }
}